import {handleAction} from 'uix/actions'

import log from 'uix/logging'

// ---Local imports
import {
  setSpecLoading,
  setDomainConfigSpec,
  setDomainConfigSections,
  loadConfigOverlay,
  setConfigOverlay,
  rebuildDomainConfig,
  rebuildDomainConfigDone,
} from './actions'

export const debug = [
  handleAction(rebuildDomainConfig, debug => ({...debug, rebuildConfigActive: true}), {
    rebuildConfigActive: false,
  }),
  handleAction(rebuildDomainConfigDone, debug => ({...debug, rebuildConfigActive: false}), {}),
]

export const config = [
  handleAction(
    setSpecLoading,
    (config, action) => {
      return {...config, dconfigSpec: 'LOADING'}
    },
    {dconfigSpec: null} // initial state
  ),
  handleAction(setDomainConfigSpec, (config, action) => {
    return {...config, dconfigSpec: action.payload.spec}
  }),
  handleAction(
    setConfigOverlay,
    (config, {payload}) => {
      return {
        ...config,
        dconfigOverlays: {...config.dconfigOverlays, [payload.dname]: payload.data},
      }
    },
    {dconfigOverlays: {}}
  ),
  handleAction(
    setDomainConfigSections,
    ({dconfigEditor, ...config}, {payload}) => {
      let {dname, sections} = payload
      let prev_editor = dconfigEditor[dname] || {}
      return {...config, dconfigEditor: {...dconfigEditor, [dname]: {...prev_editor, ...sections}}}
    },
    {dconfigEditor: {}}
  ),
]
